import { render } from "./RoleDialog.vue?vue&type=template&id=a8e87f1a"
import script from "./RoleDialog.vue?vue&type=script&lang=js"
export * from "./RoleDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__